"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const index_1 = require("../interfaces/index");
let StandardPanelExpanderComponent = class StandardPanelExpanderComponent {
    constructor(_expandablePanelCollection) {
        this._expandablePanelCollection = _expandablePanelCollection;
    }
    get panelExpanded() {
        let p = this._expandablePanelCollection.get(this.panel);
        if (p) {
            return p.isExpanded;
        }
        return false;
    }
    onBtnClick() {
        let p = this._expandablePanelCollection.get(this.panel);
        if (p) {
            p.expand();
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], StandardPanelExpanderComponent.prototype, "panel", void 0);
StandardPanelExpanderComponent = __decorate([
    core_1.Component({
        selector: 'panel-expander',
        templateUrl: './@inax/commonUi/src/expandablePanel/standardPanelExpanderComponent/standardPanelExpander.component.html',
        styleUrls: ['./@inax/commonUi/src/expandablePanel/standardPanelExpanderComponent/standardPanelExpander.component.css']
    }),
    __param(0, core_1.Inject(index_1.IEXPANDABLEPANELCOLLECTIONSERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object])
], StandardPanelExpanderComponent);
exports.StandardPanelExpanderComponent = StandardPanelExpanderComponent;
